<template>
  <div>
    <div class="flex justify-center mt-8">
      <form
        class="input-group w-full max-w-xs"
        method="GET"
      >
        <input
          id="search"
          v-model="query"
          type="text"
          class="input"
          name="search"
          value=""
          placeholder="Search For Other Organizations"
        >
        <button
          type="submit"
          class="btn"
          @click.prevent="search"
          v-text="'Find'"
        />
      </form>
    </div>
    <section
      v-if="results.length"
      class="flex flex-wrap items-stretch justify-center max-w-4xl mx-auto"
    >
      <div
        v-for="result in results"
        :key="result.uuid"
        class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
      >
        <div class="card card-bio-content text-center bg-white">
          <h6
            class="text-blue uppercase -mt-2 mb-4"
            v-text="`${result.attributes.level_name} Organization`"
          />
          <img
            :src="result.attributes.logo"
            alt=""
            class="rounded-full"
            style="width: 80%; max-width: 150px;"
          >
          <h4
            class="mb-4"
            v-text="result.attributes.name"
          />
          <AcceptRejectButtons
            v-if="result.attributes.pending_invitations.length"
            show-existing-notice
            :invitation-code="result.attributes.pending_invitations[0].code"
          />
          <a
            v-else
            class="btn btn--sm"
            :href="requestAccessToUnionLink(result)"
            v-text="'Request Access'"
          />
        </div>
      </div>
    </section>
    <div
      v-if="!results.length && hasSearched"
      class="mt-6"
      v-text="'No search results.'"
    />
  </div>
</template>

<script type="text/babel">
import AcceptRejectButtons from './AcceptRejectButtons'

export default {
  name: 'FindMyUnion',
  components: {
    AcceptRejectButtons,
  },
  data() {
    return {
      query: null,
      results: [],
      hasSearched: false,
    }
  },
  methods: {
    search() {
      this.$api.public().post('unions/search', {
        search: this.query,
      }).then(({ data }) => {
        this.hasSearched = true

        this.results = data.data
      })
    },
    requestAccessToUnionLink(Union) {
      return `${this.$urlGenerator.forUnion(Union.attributes.slug)}request-access`
    },
  },
}
</script>
